import { ExternalUserFormDto, type ExternalUserFormInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { booleanSchema } from '@zaoblako/shared/modules/serde/schemas/boolean.schema';

/** External user create request body */
export interface ExternalUserCreateInterface extends ExternalUserFormInterface {
  /** Invite profile to tenant as external user */
  invite?: boolean;
}

/** External user create request body - DTO schema */
export const ExternalUserCreateDto = SerdeDtoClass.from<ExternalUserFormInterface, ExternalUserCreateInterface>(
  ExternalUserFormDto,
  SecurityDtoKeysEnum.EXTERNAL_USER_CREATE_DTO,
  {
    invite: {
      optional: true,
      label: 'Отправить приглашение',
      serializer: booleanSchema,
    },
  },
);
